module.exports = __webpack_public_path__ + "static/media/A7407825.afcd67fe.jpg";